import { store } from "../../store/index";
import { REGIONS } from '../../types/types';

function participationUrl() {
    let currentRegion = store.getState().baseReducer.region;
    let endpoint = process.env.REACT_APP_PARTICIPATION_URL;
    return endpoint
}

export default participationUrl